import {Paper} from '@mui/material';
import React, {useCallback} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import Table from '../Contacts/Table';
import EndUserLocations from './EndUserLocations';
import NewEndUser from './NewEndUser';
import NewOrExistingContact from './NewOrExistingContact';
import NewOrExistingEndUser from './NewOrExistingEndUser';
import Who from './Who';

const SelectEndUser = ({session, onBack, onNext}) => {

  const handleBack = useCallback(() => {
    onBack(
      session.selectedContact ?
        {type: NewOrExistingEndUser.type, id: NewOrExistingEndUser.type} :
        (
          session.selectedCompany ?
            {type: NewOrExistingContact.type, id: NewOrExistingContact.type} :
            {type: Who.type, id: Who.type}
        )
    )
  }, [onBack, session]);

  return (
    <>
      <Header>Select an Existing End User</Header>
      <Paper>
        <Table
          title=""
          company={session?.selectedCompany}
          endUsers={session?.selectedCompany ? true : undefined}
          onSelect={({id, first_name, last_name}) => onNext(
            {type: EndUserLocations.type, id: EndUserLocations.type},
            {selectedEndUser: {id, first_name, last_name}}
          )}
          canCreate={false}
        />
      </Paper>
      <Controls
        onBack={handleBack}
        onNext={() => onNext({type: NewEndUser.type, id: NewEndUser.type})}
        nextLabel="Create a New End User"
      />
    </>
  );
};

SelectEndUser.type = 'SELECT_END_USER';

export default SelectEndUser;
